import { grey } from '@mui/material/colors';

export default {
  styleOverrides: {
    body: {
      backgroundColor: grey[100],
    },
  },
};
